(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/digital-tickets/digital-tickets.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/digital-tickets/digital-tickets.js');
"use strict";

const _React = React,
  Fragment = _React.Fragment;
const _svs$ui$ReactGrid = svs.ui.ReactGrid,
  GridRow = _svs$ui$ReactGrid.GridRow,
  GridCol = _svs$ui$ReactGrid.GridCol;
const PageWrapper = svs.ticket_partner.sharedComponents.pageWrapper.PageWrapper;
const WidgetArea = svs.ticket_partner.sharedComponents.widgetArea.WidgetArea;
const InformationPanels = svs.ticket_partner.sharedComponents.informationPanels.InformationPanels;
const DigitalTicketsForm = svs.ticket_partner.digitalTickets.DigitalTicketsForm;
const DigitalTickets = _ref => {
  var _svs$ticket_partner$d;
  let history = _ref.history;
  return React.createElement(Fragment, null, React.createElement(PageWrapper, null, React.createElement(DigitalTicketsForm, {
    history: history
  })), React.createElement(InformationPanels, {
    articles: (_svs$ticket_partner$d = svs.ticket_partner.data) === null || _svs$ticket_partner$d === void 0 || (_svs$ticket_partner$d = _svs$ticket_partner$d.articles) === null || _svs$ticket_partner$d === void 0 ? void 0 : _svs$ticket_partner$d.digitalTrissArticles
  }), React.createElement(PageWrapper, null, React.createElement(GridRow, {
    className: "u-flex-justify-content-center"
  }, React.createElement(GridCol, {
    className: "u-text-left",
    lg: 8,
    md: 10,
    sm: 12,
    xl: 6,
    xs: 12
  }, React.createElement(WidgetArea, {
    areaName: "digitalTrissAreaWidget"
  })))));
};
svs.ticket_partner.digitalTickets.DigitalTickets = DigitalTickets;

 })(window);